/** Build Project/Site select options from customer.consignees (GET /customers/{id}/). */
export function mapCustomerConsigneesToSiteOptions(consignees, { activeOnly = true } = {}) {
  return (consignees || [])
    .filter((site) => {
      if (!activeOnly) return true;
      return (
        site.status === true ||
        site.status === 1 ||
        site.status === '1' ||
        site.status === 'true'
      );
    })
    .map((site) => ({
      value: site.id,
      label: site.project_name || site.site_name || site.name || `Site #${site.id}`,
    }));
}

/** Build site options from GET /consignees/ consignee_list (reports / global filters). */
export function mapConsigneeListToSiteOptions(consigneeList) {
  return (consigneeList || []).map((site) => ({
    value: site.id,
    label: site.project_name || site.name || site.site_name || `Site #${site.id}`,
  }));
}
